<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle d-block">Usuário</span>
        <h3 class="page-title d-inline">Editar</h3>
        <d-link class="btn btn-success text-white float-right " href="/admin/usuarios/novo">Novo usuário</d-link>
      </d-col>
    </d-row>

    <!-- Content -->
    <user-account-details :user="user" :isCurrentUser="isUserLogged" ref="userForm" v-if="user"/>
  </d-container>
</template>

<script>
import { mapActions } from 'vuex';
import { cloneDeep } from '_utils';
import Events from '_utils/events';
import SessionService from '_services/common/sessionService';
import UserAccountDetails from '_modules/user/components/UserAccountDetails.vue';
import { _LOAD_MODEL_, MODEL } from '../components/UserModel';

export default {
  name: 'user-edit',
  components: {
    UserAccountDetails,
  },
  computed: {
    user() {
      const { userEdit } = this.$store.state.user;
      if (userEdit) {
        if (!userEdit.settings.image.url) {
          userEdit.settings.image = { ...MODEL.settings.image };
        }
        Events.$emit(_LOAD_MODEL_, userEdit);
        return userEdit;
      }
      return cloneDeep(MODEL);
    },
  },
  data() {
    return {
      isUserLogged: false,
    };
  },
  methods: {
    ...mapActions([
      'setToggle',
      'getUser',
    ]),
    getUserModel() {
      this.getUser(parseInt(this.$route.params.userId, Number));
      const user = SessionService.getLocalData('_user');
      this.isUserLogged = (parseInt(this.$route.params.userId, Number) === user.id);
    },
  },
  mounted() {
    if (this.$route.params.userId) {
      this.getUserModel();
    }
  },
};
</script>
